export default __webpack_public_path__ + "static/media/p5.49b82ad8.jpg";